import api from '../services/api';

export const getDoctorAvailabilityForecast = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.doctorType) params.append('doctorType', filters.doctorType);
  if (filters.date) params.append('date', filters.date);
  if (filters.startDate) params.append('startDate', filters.startDate);
  if (filters.endDate) params.append('endDate', filters.endDate);

  const response = await api.get(`/doctor-availability/forecast?${params.toString()}`);
  return response.data;
};
